<main class="bg-surface-container-lowest h-full">
    <sandbox-header></sandbox-header>
    <router-outlet></router-outlet>
</main>